import ProduitFormController from './produit.form.controller';

export default {
    template: require('./produit.form.html'),
    controller: ProduitFormController
};
